/**
 * The ONLY printing file that names redux keys.
 *
 * Every read the v1 print helpers made off `store.getState()` for printing is here, so a slice
 * rename breaks one file, and the rules in `@rista/printing` never see the store at all.
 */
const EMPTY: any[] = [];

export const selectPosSettings = (state: any) => state?.catalogStore?.posSettings;
export const selectChannelDefs = (state: any): any[] => state?.catalogStore?.channelDef || EMPTY;
export const selectBusinessData = (state: any) => state?.businessStore?.businessData;
export const selectSavedPrinters = (state: any): any[] => state?.printerStore?.allPrinters || EMPTY;
/** web only — mobile's printer slice has no local (OS-spooler) printers */
export const selectLocalPrinters = (state: any): any[] => state?.printerStore?.localPrinters || EMPTY;
export const selectDefaultPrinter = (state: any) => state?.printerStore?.defaultPrinter || {};
/** v1 `helper/saleHelpers.getSelectedChannel()` — the same key on both platforms */
export const selectSelectedChannelDefId = (state: any): string | undefined =>
  state?.saleDataStore?.selectedChannelData?.channelDefId;
